export default __webpack_public_path__ + "static/media/Rastech-update-5.1991c067.jpg";